import {InjectionToken} from '@angular/core';

export const SENTRY_INTERCEPTOR_CONFIG = new InjectionToken('SENTRY_INJECTION_TOKEN');
